// tslint:disable:max-line-length

import React from 'react';

export const ObjectEmployees = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M3,7c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2C1.9,3,1,3.9,1,5C1,6.1,1.9,7,3,7z" />
      <path d="M13,7c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2C11,6.1,11.9,7,13,7z" />
      <ellipse cx="8" cy="7" rx="2" ry="2" />
      <path d="M8,9.5C5.9,9.5,4.2,11,4,13h8C11.8,11,10.1,9.5,8,9.5z" />
      <path d="M8,9.5C5.9,9.5,4.2,11,4,13h8C11.8,11,10.1,9.5,8,9.5z" />
      <path d="M3,7.5C1.8,7.5,0.7,8,0,8.8V11h3.7C4.2,10.1,5,9.3,6.1,8.9C5.3,8,4.2,7.5,3,7.5z" />
      <path d="M13,7.5c-1.2,0-2.3,0.5-3.1,1.4c1,0.4,1.8,1.2,2.4,2.1H16V8.8C15.3,8,14.2,7.5,13,7.5z" />
    </svg>
  );
};
